import React, { useEffect, useState, useMemo } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Create } from "./Icons/Create.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  addCoupons,
  getBuilderList,
  getProjectListByBuilder,
  getCategoryList,
  getUnitList,
} from "../../Redux/Actions/couponsAction";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { viewCountryListPagination } from "../../Redux/Actions/settingsActions";
import InnerHeading from "../../Global Functions/innerHeading";
import TextInput from "../../Global Functions/textInput";
import SelectInput from "../../Global Functions/selectInput";
import { ToFirstCapital } from "../../Utils/helpers";
import "./addCoupons.css";

const AddCoupons = () => {
  const [couponState, setCouponState] = useState({
    code: Math.random().toString(36).substring(2, 18).toUpperCase(),
    project_id: "",
    project_type: "",
    no_of_usage: "",
    country: "",
    start_date: "",
    end_date: "",
    discount_type: "",
    discount_in: "",
    value: "",
    value_upto_show: "",
    max_value: "",
    description: "",
  });

  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [categorySections, setCategorySections] = useState([]);
  const [projectCategoriesForCoupon, setProjectCategoriesForCoupon] = useState(
    []
  );

  const [selectedBuilderId, setSelectedBuilderId] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedProjectCategories, setSelectedProjectCategories] = useState(
    []
  );

  const [
    selectedProjectCategoryDropdownId,
    setSelectedProjectCategoryDropdownId,
  ] = useState("");

  const [fetchedProjects, setFetchedProjects] = useState([]);
  const [catalogueOptions, setCatalogueOptions] = useState([]);
  const [selectedCatalogueId, setSelectedCatalogueId] = useState("");

  const [selectedUnitId, setSelectedUnitId] = useState([]);
  const [unitTypeOptions, setUnitTypeOptions] = useState([]);
  const [detailedUnitOptions, setDetailedUnitOptions] = useState([]);
  const [selectedDetailedUnitId, setSelectedDetailedUnitId] = useState([]);
  const [selectedUnitDetailsInfo, setSelectedUnitDetailsInfo] = useState([]);

  const [setSelectedFurnishingStatuses] = useState([]);

  // Discounts per selected unitId from "Select Unit"
  const [unitDiscounts, setUnitDiscounts] = useState({});

  const [combinedItems, setCombinedItems] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { countryList = { data: [] } } = useSelector(
    (state) => state.country || {}
  );
  const { enumsData = {} } = useSelector((state) => state.enumsData || {});
  const categoryList = useSelector((state) => state.coupons.categoryList || {});
  const builderList = useSelector(
    (state) => state.coupons.builderList?.data || []
  );

  useEffect(() => {
    dispatch(getEnums());
    dispatch(viewCountryListPagination());
    dispatch(getCategoryList({ page: 1, limit: 100 }));
  }, [dispatch]);

  useEffect(() => {
    if (couponState.country) {
      dispatch(
        getBuilderList({
          page: 1,
          limit: 1000,
          country_id: couponState.country,
        })
      );
    }
  }, [dispatch, couponState.country]);

  useEffect(() => {
    const fetchProjects = async () => {
      if (!selectedBuilderId || !selectedCategoryId) {
        setFetchedProjects([]);
        setSelectedProjectId("");
        setSelectedProjectCategories([]);
        setCatalogueOptions([]);
        setSelectedCatalogueId("");
        setDetailedUnitOptions([]);
        setUnitTypeOptions([]);
        setSelectedUnitId([]);
        setCouponState((prev) => ({
          ...prev,
          project_id: "",
          project_type: "",
        }));
        return;
      }

      const payload = {
        builder_id: selectedBuilderId,
        project_type: selectedCategoryId,
        status: ["published"],
        page: 1,
        limit: 30,
        is_deleted: false,
      };

      const response = await dispatch(getProjectListByBuilder(payload));
      if (response && response.data) {
        setFetchedProjects(response.data);
      } else {
        setFetchedProjects([]);
      }

      setSelectedProjectId("");
      setSelectedProjectCategories([]);
      setCatalogueOptions([]);
      setSelectedCatalogueId("");
      setDetailedUnitOptions([]);
      setUnitTypeOptions([]);
      setSelectedUnitId([]);
      setCouponState((prev) => ({ ...prev, project_id: "", project_type: "" }));
    };

    fetchProjects();
  }, [selectedBuilderId, selectedCategoryId, dispatch]);

  useEffect(() => {
    if (
      selectedProjectId &&
      selectedCategoryId &&
      selectedCatalogueId &&
      selectedProjectCategories.length > 0 &&
      couponState.project_type
    ) {
      const category_id = selectedProjectCategories[0]?._id;
      if (!category_id) {
        setDetailedUnitOptions([]);
        setUnitTypeOptions([]);
        return;
      }
      const isCommercial =
        categoryList.data
          ?.find((cat) => cat._id === selectedCategoryId)
          ?.name.toLowerCase() === "commercial";

      const payload = {
        project_id: couponState.project_id,
        project_type: couponState.project_type,
        catalogue_id: selectedCatalogueId,
        ...(isCommercial ? {} : { category_id }),
      };

      dispatch(getUnitList(payload)).then((res) => {
        if (res && res.data && Array.isArray(res.data.result)) {
          const unitTypes = res.data.result.map((group) => ({
            label: group.units ? group.units.toUpperCase() : "",
            value: group.units || "",
          }));
          setUnitTypeOptions(unitTypes);

          const combined = res.data.result.reduce((acc, group) => {
            if (Array.isArray(group.items)) {
              acc.push(...group.items);
            }
            return acc;
          }, []);
          setCombinedItems(combined);

          const detailedOptions = combined.map((unit) => ({
            label: `Floor: ${unit.floor} | Unit: ${unit.unitno} | Furnishing: ${unit.furnishingstatus}`,
            value: unit.catalogue_unit_id,
            unitType: unit.unit ? unit.unit : unit.type,
          }));
          setDetailedUnitOptions(detailedOptions);
        } else {
          setUnitTypeOptions([]);
          setDetailedUnitOptions([]);
          setCombinedItems([]);
        }
      });
    } else {
      setDetailedUnitOptions([]);
      setUnitTypeOptions([]);
      setCombinedItems([]);
    }
    setSelectedUnitId([]);
    setUnitDiscounts({});
  }, [
    selectedProjectId,
    selectedCategoryId,
    selectedCatalogueId,
    selectedProjectCategories,
    couponState.project_type,
    dispatch,
    couponState.project_id,
    categoryList.data,
  ]);

  useEffect(() => {
    setUnitDiscounts((prev) => {
      const copy = { ...prev };
      selectedUnitId.forEach((unitId) => {
        if (!copy[unitId]) {
          copy[unitId] = {
            discount_type: "",
            discount_in: "",
            value: 0,
            value_upto_show: 0,
            max_value: 0,
          };
        }
      });
      Object.keys(copy).forEach((unitId) => {
        if (!selectedUnitId.includes(unitId)) {
          delete copy[unitId];
        }
      });
      return copy;
    });
  }, [selectedUnitId]);

  const handleUnitDiscountChange = (unitId, fieldName, fieldValue) => {
    setUnitDiscounts((prev) => {
      const copy = { ...prev };
      if (!copy[unitId]) {
        copy[unitId] = {
          discount_type: "",
          discount_in: "",
          value: 0,
          value_upto_show: 0,
          max_value: 0,
        };
      }

      if (fieldName === "max_value") {
        copy[unitId][fieldName] = Number(fieldValue);
        return copy;
      }

      if (
        (fieldName === "value" || fieldName === "value_upto_show") &&
        copy[unitId].discount_in === "percent"
      ) {
        let val = Number(fieldValue);
        if (val > 100) val = 100;
        copy[unitId][fieldName] = val;
      } else if (fieldName === "discount_in") {
        copy[unitId][fieldName] = fieldValue;
        copy[unitId]["value"] = 0;
        copy[unitId]["value_upto_show"] = 0;
      } else {
        copy[unitId][fieldName] =
          fieldName === "value" || fieldName === "value_upto_show"
            ? Number(fieldValue)
            : fieldValue;
      }
      return copy;
    });
  };

  const handleDetailedUnitChange = (selectedValues) => {
    setSelectedDetailedUnitId(selectedValues);
    const selectedInfo = detailedUnitOptions
      .filter((option) => selectedValues.includes(option.value))
      .map((option) => {
        const unitData = combinedItems.find(
          (item) => item.catalogue_unit_id === option.value
        );

        return {
          catalogue_unit_id: option.value,
          unitno: unitData?.unitno || "",
          floor: unitData?.floor || "",
          furnishingstatus: unitData?.furnishingstatus || "",
        };
      });
    setSelectedUnitDetailsInfo(selectedInfo);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      let couponData = {
        code: couponState.code,
        project_id: couponState.project_id,
        project_type: couponState.project_type,
        catalogue: selectedCatalogueId || undefined,
        builder_id: selectedBuilderId,
        no_of_usage: couponState.no_of_usage,
        country_id: couponState.country,
        start_date: couponState.start_date,
        end_date: couponState.end_date,
        set_primary: couponState.set_primary,
        project_categories:
          isCommercialCategory && selectedProjectCategoryDropdownId
            ? selectedProjectCategories.filter(
              (cat) => cat._id === selectedProjectCategoryDropdownId
            )
            : projectCategoriesForCoupon,
        categories: categorySections,
        description: couponState.description,
      };

      if (selectedUnitId.length > 0) {
        const discounts = selectedUnitId.map((unitId) => {
          const discountData = unitDiscounts[unitId] || {};
          return {
            catalogue_unit_id: unitId,
            unit: unitId,
            discount_type: discountData.discount_type || "",
            discount_in: discountData.discount_in || "",
            value: discountData.value || 0,
            value_upto_show: discountData.value_upto_show || 0,
            max_value: discountData.max_value || 0,
          };
        });

        couponData.units = selectedUnitId;
        couponData.unitno = selectedUnitDetailsInfo;
        couponData.discounts = discounts;
      } else {
        couponData.discount_type = couponState.discount_type || "";
        couponData.discount_in = couponState.discount_in || "";
        couponData.value = couponState.value || 0;
        couponData.value_upto_show = couponState.value_upto_show || 0;
        couponData.max_value = couponState.max_value || 0;
      }

      const response = await dispatch(addCoupons(couponData));
      if (response?.statusCode === 200) {
        navigate("/dealsAndOffers");
        setCouponState({
          code: Math.random().toString(36).substring(2, 18).toUpperCase(),
          project_id: "",
          project_type: "",
          no_of_usage: "",
          country: "",
          start_date: "",
          end_date: "",
          discount_type: "",
          discount_in: "",
          value: "",
          value_upto_show: "",
          max_value: "",
          description: "",
          set_primary: false,
        });
        setFetchedProjects([]);
        setSelectedProjectId("");
        setSelectedBuilderId("");
        setSelectedCategoryId("");
        setCategorySections([]);
        setProjectCategoriesForCoupon([]);
        setSelectedProjectCategories([]);
        setSelectedProjectCategoryDropdownId("");
        setCatalogueOptions([]);
        setSelectedCatalogueId("");
        setDetailedUnitOptions([]);
        setUnitTypeOptions([]);
        setSelectedUnitId([]);
        setSelectedDetailedUnitId([]);
        setSelectedUnitDetailsInfo([]);
        setSelectedFurnishingStatuses([]);
        setUnitDiscounts({});
      }
    } catch (error) {
      console.error(error?.message);
    }
  };

  const handleCategoryChange = (e) => {
    const selectedId = e.target.value;
    setSelectedCategoryId(selectedId);
    setCategorySections([selectedId]);
  };

  const handleProjectChange = (e) => {
    const selectedProjectId = e.target.value;
    const selectedProject = fetchedProjects.find(
      (project) => project._id === selectedProjectId
    );

    if (!selectedProject) {
      setSelectedProjectId("");
      setCouponState((prev) => ({ ...prev, project_id: "", project_type: "" }));
      setSelectedProjectCategories([]);
      setProjectCategoriesForCoupon([]);
      setCatalogueOptions([]);
      setSelectedCatalogueId("");
      setDetailedUnitOptions([]);
      setUnitTypeOptions([]);
      setSelectedUnitId([]);
      setUnitDiscounts({});
      return;
    }

    setSelectedProjectId(selectedProjectId);

    setCouponState((prev) => ({
      ...prev,
      project_id: selectedProject._id,
      project_type: selectedProject.project_type?._id || "",
    }));

    setSelectedProjectCategories(selectedProject.categories || []);
    setProjectCategoriesForCoupon(selectedProject.categories || []);

    const selectedCategory = categoryList.data?.find(
      (cat) => cat._id === selectedCategoryId
    );
    const isCommercial = selectedCategory?.name?.toLowerCase() === "commercial";

    if (isCommercial) {
      setCatalogueOptions(
        selectedProject.catalogue_list.map((item) => ({
          label: item.tower_name || "No Tower Name",
          value: item._id,
        }))
      );
    } else {
      const categoryNames = selectedProject.categories.map((cat) =>
        cat.name?.toLowerCase()
      );
      if (categoryNames.includes("plot")) {
        setCatalogueOptions(
          selectedProject.catalogue_list.map((item) => ({
            label: item.site_name,
            value: item._id,
          }))
        );
      } else if (
        categoryNames.includes("apartment") ||
        categoryNames.includes("villa")
      ) {
        setCatalogueOptions(
          selectedProject.catalogue_list.map((item) => ({
            label:
              item.tower_name || item.catalogue_name || "No Catalogue Name",
            value: item._id,
          }))
        );
      } else {
        setCatalogueOptions([]);
      }
    }

    setSelectedCatalogueId("");
    setDetailedUnitOptions([]);
    setUnitTypeOptions([]);
    setSelectedUnitId([]);
    setUnitDiscounts({});
  };

  // const handleFurnishingChange = (e) => {
  //   const { value, checked } = e.target;
  //   setSelectedFurnishingStatuses((prev) => {
  //     if (checked) {
  //       return [...prev, value];
  //     } else {
  //       return prev.filter((status) => status !== value);
  //     }
  //   });
  // };

  // useEffect(() => {
  //   if (selectedProjectCategories.length > 0) {
  //     console.log("Selected Project Categories:", selectedProjectCategories);
  //   } else {
  //     console.log("No categories selected");
  //   }
  // }, [selectedProjectCategories]);

  const handleAddChange = (event) => {
    const { name, value } = event.target;

    setCouponState((prev) => {
      let updatedState = { ...prev, [name]: value };
      if (
        name === "start_date" &&
        new Date(updatedState.end_date) < new Date(value)
      ) {
        updatedState.end_date = value;
      }

      return updatedState;
    });
  };

  const filteredDetailedUnitOptions = useMemo(() => {
    if (selectedUnitId.length === 0 || detailedUnitOptions.length === 0) {
      return [];
    }
    return detailedUnitOptions.filter((option) =>
      selectedUnitId.includes(option.unitType)
    );
  }, [selectedUnitId, detailedUnitOptions]);

  const handleUnitChange = (e) => {
    const value = e.target.value;
    const selectedUnits = Array.isArray(value) ? value : [value];
    setSelectedUnitId(selectedUnits);

    const filteredDetailed = selectedDetailedUnitId.filter((detailedId) => {
      const option = detailedUnitOptions.find(
        (opt) => opt.value === detailedId
      );
      return option && selectedUnits.includes(option.unitType);
    });
    setSelectedDetailedUnitId(filteredDetailed);
    handleDetailedUnitChange(filteredDetailed);
  };

  // useEffect(() => {
  //   console.log("Catalogue Options:", catalogueOptions);
  //   console.log("Selected Catalogue ID:", selectedCatalogueId);
  // }, [catalogueOptions, selectedCatalogueId]);

  const filterDetailedByFurnishing = (status) => {
    const options = detailedUnitOptions.filter((opt) => {
      const match = opt.label.match(/Furnishing: ([^|]+)/i);
      return (
        match !== null &&
        typeof match[1] === "string" &&
        match[1].toLowerCase().replace(/\s/g, "") === status &&
        selectedUnitId.includes(opt.unitType)
      );
    });
    const values = options.map((opt) => opt.value);
    setSelectedDetailedUnitId(values);
    handleDetailedUnitChange(values);
  };

  const isCommercialCategory = useMemo(() => {
    const selectedCategory = categoryList.data?.find(
      (cat) => cat._id === selectedCategoryId
    );
    return selectedCategory?.name?.toLowerCase() === "commercial";
  }, [selectedCategoryId, categoryList]);

  // useEffect(() => {
  //   console.log("All fetched projects:", fetchedProjects);
  // }, [fetchedProjects]);

  return (
    <MainLayout>
      <div className="overall-container-grid ">
        <InnerHeading
          Icon={Create}
          heading="Create Coupon"
          buttonLabel="View Coupons"
          onClick={() => navigate("/dealsAndOffers")}
        />

        <TextInput
          value={couponState.code}
          disabled
          required
          label="Coupon Code"
        />
        <SelectInput
          // required
          value={couponState.country}
          label={<span>
            Country<span style={{ color: "red" }}>*</span>
          </span>}
          name="country"
          onChange={handleAddChange}
          placeholder="Select an Option"
          options={
            Array.isArray(countryList?.data)
              ? countryList.data.map((country) => ({
                label: country.country_name,
                value: country._id,
              }))
              : []
          }
        />

        <SelectInput
          label={<span>Select Builder <span style={{ color: "red" }}>*</span></span>}
          value={selectedBuilderId}
          name="builder_id"
          onChange={(e) => setSelectedBuilderId(e.target.value)}
          placeholder="Select a Builder"
          options={
            builderList.length > 0
              ? builderList.map((builder) => ({
                label: `${builder.brand_name}`,
                value: builder._id,
              }))
              : []
          }
          disabled={!couponState.country}
        />

        <SelectInput
          label={<span>Select Category Section<span style={{ color: "red" }}>*</span></span>}
          value={selectedCategoryId}
          name="category_id"
          onChange={handleCategoryChange}
          placeholder="Select a Category Section"
          options={
            categoryList.data && Array.isArray(categoryList.data)
              ? categoryList.data.map((cat) => ({
                label: cat.name,
                value: cat._id,
              }))
              : []
          }
        />

        <SelectInput
          value={selectedProjectId}
          className="input-class"
          name="project_id"
          // required
          label={<span>
            Select Project<span style={{ color: "red" }}>*</span>
          </span>}
          placeholder="Select an Option"
          options={
            Array.isArray(fetchedProjects) && fetchedProjects.length > 0
              ? fetchedProjects.map((project) => ({
                label: project.project_name,
                value: project._id,
              }))
              : [{ label: "No data", value: "", disabled: true }]
          }
          onChange={handleProjectChange}
        />

        {!isCommercialCategory && (
          <SelectInput
            label={<span>Select Project Category<span style={{ color: "red" }}>*</span></span>}
            value={selectedProjectCategoryDropdownId}
            name="project_category_id"
            onChange={(e) =>
              setSelectedProjectCategoryDropdownId(e.target.value)
            }
            placeholder="Select Project Category"
            options={selectedProjectCategories.map((cat) => ({
              label: cat.name,
              value: cat._id,
              icon: cat.icon,
            }))}
          />
        )}

        <SelectInput
          value={selectedCatalogueId}
          label="Select Catalogue"
          name="catalogue_id"
          onChange={(e) => setSelectedCatalogueId(e.target.value)}
          placeholder="Select Catalogue"
          options={
            catalogueOptions.length > 0
              ? catalogueOptions
              : [{ label: "No data", value: "", disabled: true }]
          }
        />

        <SelectInput
          label="Select Type"
          name="unit_id"
          onChange={handleUnitChange}
          value={selectedUnitId}
          placeholder="Select Type"
          options={
            unitTypeOptions.length > 0
              ? unitTypeOptions
              : [{ label: "No data", value: "", disabled: true }]
          }
        // multiSelect={true}
        />

        {/* Per-unit discounts only if units selected */}
        {selectedUnitId.length > 0 && (
          <div className="per-unit-discounts-container">
            {/* <h3>Discount Details Per Unit</h3> */}
            {selectedUnitId.map((unitId) => {
              const discount = unitDiscounts[unitId] || {
                discount_type: "",
                discount_in: "",
                value: 0,
                value_upto_show: 0,
                max_value: 0,
              };
              // const unitLabel =
              //   unitTypeOptions.find((opt) => opt.value === unitId)?.label ||
              //   unitId;

              const isPercent = discount.discount_in === "percent";

              return (
                <div key={unitId} className="unit-discount-block">
                  {/* <h4>{unitLabel}</h4> */}

                  <SelectInput
                    label="Discount Type"
                    required
                    value={discount.discount_type}
                    onChange={(e) =>
                      handleUnitDiscountChange(
                        unitId,
                        "discount_type",
                        e.target.value
                      )
                    }
                    placeholder="Select Discount Type"
                    options={
                      enumsData?.data?.DiscountType
                        ? Object.entries(enumsData.data.DiscountType).map(
                          ([_key, value]) => ({
                            label: ToFirstCapital(value),
                            value,
                          })
                        )
                        : []
                    }
                  />

                  <SelectInput
                    label="Discount Format"
                    required
                    value={discount.discount_in}
                    onChange={(e) =>
                      handleUnitDiscountChange(
                        unitId,
                        "discount_in",
                        e.target.value
                      )
                    }
                    placeholder="Select Discount Format"
                    options={
                      enumsData?.data?.DiscountFormat
                        ? Object.entries(enumsData.data.DiscountFormat).map(
                          ([_key, value]) => ({
                            label: ToFirstCapital(value),
                            value,
                          })
                        )
                        : []
                    }
                  />

                  <TextInput
                    label="Coupon Value"
                    type="number"
                    min={0}
                    max={isPercent ? 100 : undefined}
                    value={discount.value === 0 ? "" : discount.value}
                    onChange={(e) =>
                      handleUnitDiscountChange(unitId, "value", e.target.value)
                    }
                  />

                  {discount.discount_type === "upto" &&
                    discount.discount_in === "percent" && (
                      <TextInput
                        label="Max Value"
                        type="number"
                        min={0}
                        max={100}
                        value={
                          discount.max_value === 0 ? "" : discount.max_value
                        }
                        onChange={(e) =>
                          handleUnitDiscountChange(
                            unitId,
                            "max_value",
                            e.target.value
                          )
                        }
                      />
                    )}

                  {discount.discount_type === "upto" && (
                    <TextInput
                      label="Coupon Show Upto Value"
                      type="number"
                      min={0}
                      max={isPercent ? 100 : undefined}
                      value={
                        discount.value_upto_show === 0
                          ? ""
                          : discount.value_upto_show
                      }
                      onChange={(e) =>
                        handleUnitDiscountChange(
                          unitId,
                          "value_upto_show",
                          e.target.value
                        )
                      }
                    />
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* Single discount fields only if no units selected */}
        {selectedUnitId.length === 0 && (
          <div className="single-discount-fields">
            <SelectInput
              label="Discount Type"
              name="discount_type"
              value={couponState.discount_type || ""}
              onChange={handleAddChange}
              placeholder="Select Discount Type"
              options={
                enumsData?.data?.DiscountType
                  ? Object.entries(enumsData.data.DiscountType).map(
                    ([_key, value]) => ({
                      label: ToFirstCapital(value),
                      value,
                    })
                  )
                  : []
              }
            />
            <SelectInput
              label="Discount Format"
              name="discount_in"
              value={couponState.discount_in || ""}
              onChange={handleAddChange}
              placeholder="Select Discount Format"
              options={
                enumsData?.data?.DiscountFormat
                  ? Object.entries(enumsData.data.DiscountFormat).map(
                    ([_key, value]) => ({
                      label: ToFirstCapital(value),
                      value,
                    })
                  )
                  : []
              }
            />

            <TextInput
              label="Coupon Value"
              type="number"
              name="value"
              value={couponState.value || ""}
              min={0}
              max={couponState.discount_in === "percent" ? 100 : undefined}
              onChange={(e) => {
                let val = Number(e.target.value);
                if (couponState.discount_in === "percent" && val > 100)
                  val = 100;
                handleAddChange({ target: { name: "value", value: val } });
              }}
            />

            {couponState.discount_type === "upto" &&
              couponState.discount_in === "percent" && (
                <TextInput
                  label="Max Value"
                  type="number"
                  name="max_value"
                  min={0}
                  max={100}
                  value={couponState.max_value || ""}
                  onChange={handleAddChange}
                />
              )}

            {couponState.discount_type === "upto" && (
              <TextInput
                label="Coupon Show Upto Value"
                type="number"
                name="value_upto_show"
                value={couponState.value_upto_show || ""}
                min={0}
                max={couponState.discount_in === "percent" ? 100 : undefined}
                onChange={(e) => {
                  let val = Number(e.target.value);
                  if (couponState.discount_in === "percent" && val > 100)
                    val = 100;
                  handleAddChange({
                    target: { name: "value_upto_show", value: val },
                  });
                }}
              />
            )}
          </div>
        )}

        <SelectInput
          label="Select Unit Detail (Floor | Unit | Furnishing)"
          value={selectedDetailedUnitId}
          name="detailed_unit_id"
          onChange={(e) => handleDetailedUnitChange(e.target.value)}
          placeholder="Select Unit Detail"
          options={
            filteredDetailedUnitOptions.length > 0
              ? filteredDetailedUnitOptions
              : [{ label: "No data", value: "", disabled: true }]
          }
          multiSelect={true}
        />
        {selectedUnitId.length > 0 &&
          <div style={{ marginTop: "10px", marginBottom: "10px" }}>
            <button
              className="select-all-button"
              type="button"
              onClick={() => filterDetailedByFurnishing("furnished")}
            >
              Furnished
            </button>
            <button
              className="select-all-button"
              type="button"
              style={{ marginLeft: "8px" }}
              onClick={() => filterDetailedByFurnishing("semifurnished")}
            >
              Semi-Furnished
            </button>
            <button
              className="select-all-button"
              type="button"
              style={{ marginLeft: "8px" }}
              onClick={() => filterDetailedByFurnishing("unfurnished")}
            >
              Un-Furnished
            </button>
            <button
              type="button"
              className="select-all-button"
              style={{ marginLeft: "12px" }}
              onClick={() => {
                const allOptionsValues = detailedUnitOptions
                  .filter((opt) => selectedUnitId.includes(opt.unitType))
                  .map((option) => option.value);
                setSelectedDetailedUnitId(allOptionsValues);
                handleDetailedUnitChange(allOptionsValues);
              }}
            >
              Select All
            </button>
            {selectedDetailedUnitId.length > 0 && (
              <button
                type="button"
                className="unselect-all-button"
                style={{ marginLeft: "8px" }}
                onClick={() => {
                  setSelectedDetailedUnitId([]);
                  setSelectedUnitDetailsInfo([]);
                }}
              >
                Unselect All
              </button>
            )}
          </div>
        }

        <div className="gap-10 flex-container">
          <div style={{ width: "50%" }}>
            <TextInput
              value={couponState.start_date}
              onChange={handleAddChange}
              type="date"
              label="Valid From"
              required
              name="start_date"
              min={new Date().toISOString().split("T")[0]}
              max={couponState.end_date}
            />
          </div>
          <div style={{ width: "50%" }}>
            <TextInput
              value={couponState.end_date}
              onChange={handleAddChange}
              type="date"
              required
              label="Valid Till"
              name="end_date"
              min={
                couponState.start_date || new Date().toISOString().split("T")[0]
              }
            />
          </div>
        </div>

        <TextInput
          onChange={handleAddChange}
          type="number"
          required
          label="No. of Usages"
          name="no_of_usage"
          min={0}
          value={couponState.no_of_usage}
        />

        <div className="form-group">
          <label>Description</label>
          <textarea
            name="description"
            value={couponState.description}
            onChange={handleAddChange}
            rows={3}
            placeholder="Add description for this coupon"
          />
        </div>

        <div className="form-group toggle-checkbox">
          <label className="switch-label">
            Set Primary (optional)
            <input
              type="checkbox"
              name="set_primary"
              checked={couponState.set_primary}
              onChange={(e) =>
                setCouponState((prev) => ({
                  ...prev,
                  set_primary: e.target.checked,
                }))
              }
            />
            <span className="slider"></span>
          </label>
        </div>

        <div className="flex-end gap-10 span2">
          <button onClick={handleSubmit} className="button-class">
            Save
          </button>
          <Link to="/dealsAndOffers">
            <button className="button-class-white">Cancel</button>
          </Link>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddCoupons;
